var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"menu-item-container"},[_c('li',{staticClass:"item",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"icon"},[_vm._t("header")],2),_c('span',{staticClass:"item-content"},[_vm._t("default",function(){return [_vm._v("name")]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }